import { useLocation } from 'react-router-dom';
import { useState, useContext, useEffect } from 'react';
import HeaderCommon from '../components/HeaderCommon';

export default function TermsPage() {
    const location = useLocation()
    const [offerData, setofferData] = useState(location?.state?.offerDetails)
    let mediaQueryList = window.matchMedia("(min-width: 992px)");
    const [isLargeDisplay, setisLargeDisplay] = useState(mediaQueryList.matches)

    function checkDevice(mql) {
        setisLargeDisplay(mql.matches)
    }

    useEffect(() => {
        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener("change", checkDevice)
        }
        else {
            mediaQueryList.addListener(checkDevice)
        }
        return () => {
            if (mediaQueryList.addEventListener) {
                mediaQueryList.removeEventListener("change", checkDevice)
            } else {
                mediaQueryList.removeListener(checkDevice)
            }
        }
    }, [])

    return (
        <div>
            {!isLargeDisplay && <HeaderCommon />}
            <div style={{ padding: '15px' }}>
                <h2 style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 15 }}>Offer Terms & Conditions</h2>
                <div>{offerData}</div>
            </div>
        </div>
    )
}